import React  from 'react';
import axios from 'axios'
import {useState, useEffect, Fragment } from 'react';

const LIST_TERMS_URL = `${process.env.REACT_APP_API_URL}/taxonomies/terms?vocabulary=`
const headers = {
    "Content-Type" : "application/hal+json",
    "Accept" : "application/hal+json"
}

const GetTaxoTerms = (props: any) => {

    const initOpt = [{tid: 'all', name: '-'}]

    const [options, setOptions] = useState(initOpt)

    useEffect(()=>{
        async function getList(){
            axios.get(LIST_TERMS_URL+ props.name, {headers})
                .then((res:any)=>{
                    setOptions(res.data)
                })
                .catch((e) => {
                    console.log(e);
                });
        }
        getList()
    },[props.name])

    return(
        <>
            <option value=''>- Select {props.title} -</option>
            {options.map((opt: any, key: any)=>(
                <option key={key} value={opt.tid}>{opt.name}</option>
            ))}
        </>
    )
}

export default GetTaxoTerms